import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, finalize, map, retry, switchMap } from 'rxjs/operators';

import { DataCollectionInterface } from '../interfaces/data-collection.interface';
import { DataCollectionFacadeService } from '../services/data-collection-facade.service';
import { DATA_COLLECTION_ROUTE_ID_KEY } from '../constants/constants';

const START_TIMEOUT = 100;
const RETRY_COUNT = 10;

@Injectable()
export class DataCollectionResolver {
    constructor(
        private readonly dataService: DataCollectionFacadeService,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<DataCollectionInterface> | Promise<DataCollectionInterface> | DataCollectionInterface {
        this.dataService.loadingStart();

        return timer(START_TIMEOUT)
            .pipe(
                switchMap(() => {
                    const id = route.paramMap.get(DATA_COLLECTION_ROUTE_ID_KEY);

                    if (!id) {
                        throw new Error('Data collection route error. Please, restart application.');
                    }

                    return this.dataService.getDataCollection$(id);
                }),
                map(dataCollection => {
                    if (!dataCollection) {
                        throw new Error('Application error. Please, restart application.');
                    }

                    return dataCollection;
                }),
                retry({
                    count: RETRY_COUNT,
                    delay: START_TIMEOUT,
                    resetOnSuccess: true // Reset the retry count if the stream succeeds later
                }),
                catchError((error) => {
                    this.dataService.showAlert(error.message);

                    return throwError(() => error);
                }),
                finalize(() => {
                    this.dataService.loadingEnd();
                }),
            );
    }
}
